import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { OT_SHOW_CHAT_IFRAME } from '../../flags/features';
import { isFeatureActive } from '../../selectors/configSelectors';
import configUtil from '../../utils/config';

import styles from './styles.scss';

export class ChatWebClient extends Component {
  constructor(props) {
    super(props);
    this.iframeEl = React.createRef();
  }

  componentDidMount() {
    if (!this.props.isShowChatEnabled) return;
    this.iframeEl.current.src = configUtil.chatWebClientURL;
    this.iframeEl.current.addEventListener('load', this.handleOnIframeLoad.bind(this));
  }

  handleOnIframeLoad(event) {
    const payload = {
      actorId: this.props.userId,
      actorToken: this.props.consumerAuthToken,
      orderId: this.props.orderId,
    };

    event.target.contentWindow.postMessage(
      {
        source: 'cwa-chat-web-client',
        payload,
      },
      configUtil.chatWebClientURL,
    );
  }

  render() {
    return (
      this.props.isShowChatEnabled && (
        <div className={styles.wrapper}>
          <iframe title="web-client" className={styles.iframe} ref={this.iframeEl} />
        </div>
      )
    );
  }
}

ChatWebClient.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  consumerAuthToken: PropTypes.string.isRequired,
  isShowChatEnabled: PropTypes.bool,
};

ChatWebClient.defaultProps = {
  isShowChatEnabled: false,
};

export default connect((state) => ({
  userId: state.user.id,
  consumerAuthToken: state.request.apiAuth,
  isShowChatEnabled: isFeatureActive(state, OT_SHOW_CHAT_IFRAME),
}))(ChatWebClient);
